import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto h-full px-6 pt-14 z-50" }
const _hoisted_2 = { class: "flex flex-col space-y-6" }
const _hoisted_3 = { class: "flex flex-col w-full items-center space-y-2" }
const _hoisted_4 = { class: "m-auto text-brand-light-gray text-lg text-center" }
const _hoisted_5 = { class: "text-brand-lime" }
const _hoisted_6 = { class: "flex flex-col space-y-3" }
const _hoisted_7 = { class: "flex w-full flex-col bg-brand-dark-gray rounded-lg h-14 relative" }
const _hoisted_8 = { class: "flex w-full flex-col bg-brand-dark-gray rounded-lg h-14 relative" }
const _hoisted_9 = { class: "flex w-full flex-col bg-brand-dark-gray rounded-lg h-14 relative" }
const _hoisted_10 = {
  key: 0,
  class: "text-red-400 text-sm px-1"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "flex m-auto space-x-2.5" }
const _hoisted_13 = { class: "my-auto pt-0.5" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "animate-spin h-5 w-5 text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex m-auto text-white text-2xl font-medium" }, "Reset your password", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _cache[5] || (_cache[5] = _createTextVNode(" We emailed a 6-character code to ", -1)),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.email), 1),
                  _cache[6] || (_cache[6] = _createTextVNode(". Enter it below with your new password. ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.code,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
                    class: "text-white text-lg font-medium absolute top-0 left-0 h-full px-4",
                    placeholder: "6-character code",
                    maxlength: "6",
                    autocapitalize: "characters"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    class: "text-white text-lg font-medium absolute top-0 left-0 h-full px-4",
                    placeholder: "New password",
                    type: "password"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.passwordConfirmation,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
                    class: "text-white text-lg font-medium absolute top-0 left-0 h-full px-4",
                    placeholder: "Confirm password",
                    type: "password"
                  }, null, 8, ["modelValue"])
                ]),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
              disabled: _ctx.busy || !_ctx.canSubmit,
              class: "mt-10 flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black disabled:opacity-40"
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (!_ctx.busy)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Set new password"))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        }, null, -1)
                      ]))]))
                ])
              ])
            ], 8, _hoisted_11),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resend && _ctx.resend(...args))),
              disabled: _ctx.busy,
              class: "mt-2 flex rounded-full w-full h-14 font-medium text-xl text-white disabled:opacity-40"
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
                _createElementVNode("div", { class: "my-auto pt-0.5" }, " Resend code ")
              ], -1)
            ]))], 8, _hoisted_16)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}